var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#383838"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 11.446C8.3335 10.6953 8.59627 10.0759 9.12178 9.58794C9.6473 9.09994 10.3305 8.85596 11.1713 8.85596C11.9972 8.85596 12.6653 9.09618 13.1758 9.57668C13.7014 10.0722 13.9641 10.7178 13.9641 11.5136C13.9641 12.2343 13.7089 12.8349 13.1984 13.3154C12.6728 13.8109 11.9821 14.0587 11.1263 14.0587H11.1038C10.2779 14.0587 9.60978 13.8109 9.09926 13.3154C8.58874 12.8199 8.3335 12.1968 8.3335 11.446ZM8.62629 31.1533V16.1082H13.6263V31.1533H8.62629ZM16.3966 31.1533H21.3966V22.7524C21.3966 22.2268 21.4566 21.8214 21.5767 21.5361C21.7869 21.0256 22.106 20.5939 22.5339 20.2411C22.9619 19.8882 23.4987 19.7118 24.1443 19.7118C25.826 19.7118 26.6668 20.8454 26.6668 23.1127V31.1533H31.6668V22.5271C31.6668 20.3049 31.1413 18.6195 30.0903 17.4708C29.0392 16.3222 27.6503 15.7478 25.9236 15.7478C23.9866 15.7478 22.4776 16.5812 21.3966 18.2478V18.2929H21.374L21.3966 18.2478V16.1082H16.3966C16.4266 16.5887 16.4416 18.0827 16.4416 20.5902C16.4416 23.0977 16.4266 26.6187 16.3966 31.1533Z",
    fill: "#1E1E1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_169"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.3335,
    y: 8.33325,
    width: 23.3333,
    height: 23.3333,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/in.4109a366391ed52f7e813f7bc0fcbdf9.svg";
export { ForwardRef as ReactComponent };